import {cancelExpedient} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../expedient-keys";

export function cancelExpedientMutationOptions() {
  return mutationOptions({
    mutationKey: expedientMutationKeys.cancelExpedient,
    mutationFn: (id: string) => cancelExpedient(id),
    onSuccess: async (_result, id, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: expedientKeys.detail(id)}),
        client.invalidateQueries({queryKey: expedientKeys.lists()}),
      ]);
    },
  });
}
